import setCarePlanIcd10Codes from './setCarePlanIcd10Codes';
import addCarePlanIcd10Codes from './addCarePlanIcd10Codes';
import updateCarePlanIcd10Code from './updateCarePlanIcd10Code';
import removeCarePlanIcd10Code from './removeCarePlanIcd10Code';

export default {
  setCarePlanIcd10Codes,
  addCarePlanIcd10Codes,
  updateCarePlanIcd10Code,
  removeCarePlanIcd10Code,
};
